'use client';

import { useMemo } from 'react';
import { useRegionCurrency } from '../../context';
import { useSiteconfigService } from './useSiteconfigService';

export const useGetShippingPolicy = () => {
  const { country } = useRegionCurrency();
  const { useGetShippingPolicies } = useSiteconfigService();
  const { data: shippingPolicies } = useGetShippingPolicies();

  const shippingPolicy = useMemo(() => {
    return shippingPolicies?.config.find((policy) => policy.countryCode === country);
  }, [shippingPolicies, country]);

  return { shippingPolicy };
};
